import React, { useState } from "react";
import * as M from "./RepurchaseModalStyle";
import PDFGenerator from "../CompraModal/PDFGenerator";
import { useMessage } from "../../../context/MessageContext";
import { contractService } from "../../../Services/contractService";
import { formatNumber } from "../../../assets/utils";
import Loading from "../../Loading/Loader";

export default function RepurchaseModal({
  modalData,
  totalCost,
  availableBalance,
  onClose,
  onSuccess,
}) {
  const { showMessage } = useMessage();
  const [loading, setLoading] = useState(false);
  const [assinatura, setAssinatura] = useState("");

  const hasSufficientBalance = availableBalance >= totalCost;

  const handleCheckboxChange = (event) => {
    setAssinatura(event.target.checked ? "assinado" : "");
  };

  const handleConfirmRepurchase = async () => {
    if (!hasSufficientBalance) {
      showMessage("Seu saldo é insuficiente.", "error");
      return;
    }
    if (assinatura !== "assinado") {
      showMessage("Por favor, assine o contrato para continuar.", "warning");
      return;
    }

    setLoading(true);
    try {
      await contractService.repurchaseWithBalance(modalData.qttContratos);
      showMessage(
        `Recompra de ${modalData.qttContratos} contratos realizada com sucesso!`,
        "success"
      );
      onSuccess();
    } catch (error) {
      const errorMsg =
        error.response?.data?.message ||
        "Ocorreu um erro ao processar a recompra.";
      showMessage(errorMsg, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <M.ModalContainer>
      <M.ModalBox>
        {loading && (
          <M.LoadingOverlay>
            <Loading load={loading} />
          </M.LoadingOverlay>
        )}
        <M.Header>
          <M.Title>Recompra com Saldo</M.Title>
          <M.CloseButton onClick={onClose}>&times;</M.CloseButton>
        </M.Header>

        {hasSufficientBalance ? (
          // --- VISUALIZAÇÃO QUANDO HÁ SALDO SUFICIENTE ---
          <>
            <M.ModalPDFContainer>
              <PDFGenerator ContratoData={modalData} assinatura={assinatura} />
            </M.ModalPDFContainer>
            <M.Footer>
              <M.CheckboxContainer>
                <input
                  type="checkbox"
                  id="repurchase-signature"
                  onChange={handleCheckboxChange}
                  checked={assinatura === "assinado"}
                />
                <label htmlFor="repurchase-signature">
                  Li e concordo com os termos. Assinar contrato.
                </label>
              </M.CheckboxContainer>
              <M.ConfirmButton
                onClick={handleConfirmRepurchase}
                disabled={assinatura !== "assinado"}
              >
                Confirmar Recompra (R$ {formatNumber(totalCost)})
              </M.ConfirmButton>
            </M.Footer>
          </>
        ) : (
          // --- VISUALIZAÇÃO QUANDO O SALDO É INSUFICIENTE ---
          <M.Content>
            <M.InsufficientBalanceBox>
              <M.Icon>⚠️</M.Icon>
              <M.InsufficientTitle>Saldo Insuficiente</M.InsufficientTitle>
              <M.InsufficientText>
                Você não possui saldo suficiente para realizar esta operação.
              </M.InsufficientText>
              <M.InfoSection>
                <M.InfoRow>
                  <M.InfoLabel>Saldo Disponível:</M.InfoLabel>
                  <M.InfoValue color="#2ecc71">
                    R$ {formatNumber(availableBalance)}
                  </M.InfoValue>
                </M.InfoRow>
                <M.InfoRow>
                  <M.InfoLabel>Valor Necessário:</M.InfoLabel>
                  <M.InfoValue color="#e74c3c">
                    R$ {formatNumber(totalCost)}
                  </M.InfoValue>
                </M.InfoRow>
              </M.InfoSection>
              <M.BackButton onClick={onClose}>
                Voltar para Simulação
              </M.BackButton>
            </M.InsufficientBalanceBox>
          </M.Content>
        )}
      </M.ModalBox>
    </M.ModalContainer>
  );
}
